import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ce-container',
    imports: [CommonModule],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ce-container.component.html',
    styleUrl: './ce-container.component.scss',
    host: {
        class: 'CeContainer ce-typography-group',
        '[class.CeContainer--wizard]': 'variant === "wizard"',
        '[class.CeContainer--narrow]': 'variant === "narrow"',
    }
})
export class CeContainerComponent {
    @Input() variant?: 'wizard' | 'narrow';
}
